<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <div class="app-login">
    <pro-alerta :texto="info_alerta" :cor="cor_alerta" :show="show_alerta" @abriAlerta="fechar_alerta"></pro-alerta>
    
    <v-container>
      <v-row style="height: 90vh;" justify="center">
        <v-col align-self="center" cols="12" sm="12" md="10" lg="9">
          <v-card class="pa-2" style="background: white!important">
            <v-card-text>
              <v-row justify="center">
                <v-col cols="12" sm="12" md="5">
                  <div class="sm-list-txt" style="margin-top: 15%">
                    <v-img :src="logo_cor" alt="" style="height: 200px" contain></v-img>
                  </div>
                </v-col>
                <v-col cols="12" sm="12" md="7" class="login_steppers">
                  <v-card class="mx-auto" flat>
                    <v-card-subtitle>
                      <h2>{{step===0?'Login':'Empresa'}}</h2>
                      <span>{{step===0?'Informe o usuário e a senha':'Informe a empresa'}}</span>
                    </v-card-subtitle>
                    
                    <v-window v-model="step">
                      <v-window-item :value="0">
                        <v-card-text style="height: 150px">
                          <v-row>
                            <!--<v-col cols="12">-->
                              <!--<small>Informe o usuário e a senha</small>-->
                            <!--</v-col>-->
                            <v-col cols="12">
                              <v-text-field name="usuario" dense outlined class="inp" v-model="user.username"
                                            label="Usuário" id="usuario" prepend-inner-icon="mdi-account" hide-details
                                            v-on:keyup="PressEnter(user.senha, user.username,2)" required></v-text-field>
                            </v-col>
                            <v-col cols="12">
                              <v-text-field name="senha"  dense outlined class="inp" v-model="user.senha" label="Senha"
                                            prepend-inner-icon="mdi-lock" type="password" id="senha" required hide-details
                                            v-on:keyup="PressEnter(user.senha, user.username,2)"></v-text-field>
                            </v-col>
                            
                          </v-row>
                        </v-card-text>
                      </v-window-item>
                      
                      <v-window-item :value="1" >
                        <v-card-text style="height: 150px">
                          <v-row>
                            <!--<v-col cols="12">-->
                              <!--<small>Informe a empresa </small>-->
                            <!--</v-col>-->
                            <v-col cols="12" v-if="varias_empresas">
                              <v-select id="select_empresa" v-model="empresa" :focused="true"  :items="listaAllEmpresaFunc"
                                        item-text="nome"  dense outlined
                                        item-value="empresa_id" return-object class="inp"
                                        label="Empresas" >
                              </v-select>
                            </v-col>
                          </v-row>
                        </v-card-text>
                      </v-window-item>
                    </v-window>
                    
                    <v-card-actions>
                      <v-btn v-if="step > 0" color="primary"   text @click="step--">
                        Anterior
                      </v-btn>
                      <v-spacer></v-spacer>
                      <v-btn color="primary"  @click="logar()" :loading="spinner2">
                        {{step < 1 ? 'Avançar' : 'Entrar'}}
                      </v-btn>
                    </v-card-actions>
                  </v-card>
                </v-col>
              
              </v-row>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
    
    <!-- Dialog que vai exibir a lista de erros caso aja uma validação -->
    <v-dialog v-model="dialogError" width="40%">
      <v-card v-if="objMsgError !== null">
        <v-card-title class="gradiente">{{ objMsgError.message }}</v-card-title>
        <v-divider></v-divider>
        
        <v-card-text>
          <div v-if="objMsgError.details !== null">
            <v-container>
              <ul :key="index" v-for="(message, index) in objMsgError.details">
                <li> {{ message.mensagem }}</li>
              </ul>
            </v-container>
          </div>
        </v-card-text>
        
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn size="small" color="green darken-1" text @click="toggleDialogError()" aria-label="fechar">
            Fechar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    
    <!-- Popup que vai exibir mensagens de sucesso -->
    <v-snackbar v-model="showSnack" location="top" color="success" :timeout="200000">
      {{ msgSuccess }}
      <template v-slot:actions>
        <v-icon aria-label="close" @click="toggleSnackSuccess">mdi-close</v-icon>
      </template>
    </v-snackbar>
  </div>
</template>

<script>
  /* eslint-disable */
  import miscMixin from '../../helpers/misc'
  import {mapActions, mapGetters, mapState} from "vuex";
  import logo_cor from '../../assets/img/logo/casa_santos.svg'
  import router from '../../router'
  import {Tema} from "../../models/tema";
  import ModalCadastro from "../../components/ModalCadastro";
  
  export default {
    mixins: [miscMixin],
    data: () => ({
      logo_cor,
      step: 0,
      empresa: null,
      empresas: [],
      steps: 0,
      fixed: true,
      user: [],
      spinner2: false,
      valid: false,
      name: '',
      usuarioAutenticado: null,
      varias_empresas: false,
      nameRules: [
        v => !!v || 'Digite o usuario',
        v => v.length <= 3 || 'O nome deve ter mais de 3 letra'
      ],
      senha: '',
      senhaRules: [
        v => !!v || 'Digite a senha',
        v => v.length <= 3 || 'A senha deve ter mais de 3 letra'
      ]
    }),
    components: { ModalCadastro},
    
    methods: {
      // ...mapActions('usuario', ['autenticaUsuarios']),
      // ...mapActions('geral', ['setModal', 'toggleDialogError', 'toggleSnackSuccess']),
      ...mapActions('empresa', ['setEmpresaByFuncionario', 'getEmpresa']),
      ...mapActions('usuario', ['autenticarUsuario']),
      ...mapActions('geral', ['setModal', 'toggleDialogError', 'toggleSnackSuccess','setMsgSuccess']),
      ...mapActions('configuracao', ['setTema']),
      logar() {
        
        if (this.step <= 0) {
          this.efetuaLogin(this.user, 2)
          
        } else {
          if (this.validarCampo(this.empresa)) {
            
            this.confirmar()
          } else {
            this.open_alerta('Selecione a EMPRESA', 'red')
          }
        }
      },
      confirmar() {
        if (sessionStorage.getItem('empresa_id')) {
          // let interv =
          //   setTimeout(function () {
          
          this.open_alerta('Registro autenticado com sucesso.', 'success')
          
          router.push({name: 'Home'}).catch();
          // clearInterval(interv)
          // }, 1000)
        }
      },
      setarSemana(usuario) {
        let d = new Date();
        let hora = this.zeroEsquerda(d.getHours(), 2) + '' + this.zeroEsquerda(d.getMinutes(), 2);
        let semana = [
          {dia_semana: 1, descricao: 'Domingo'},
          {dia_semana: 2, descricao: 'Segunda-Feira'},
          {dia_semana: 3, descricao: 'Terça-Feira'},
          {dia_semana: 4, descricao: 'Quarta-Feira'},
          {dia_semana: 5, descricao: 'Quinta-Feira'},
          {dia_semana: 6, descricao: 'Sexta-Feira'},
          {dia_semana: 7, descricao: 'Sábado'},
        ];
        
        let dia_semana = semana[d.getDay()].dia_semana;
        
        return {
          username: this.retorno(this.validarCampo(usuario.username), true, usuario.username, ""),
          senha: this.retorno(this.validarCampo(usuario.senha), true, usuario.senha, ""),
          empresa_id: this.retorno(this.validarCampo(usuario.empresa_id), true, usuario.empresa_id, ""),
          acessibilidade: {dia: dia_semana, hora: hora}
        };
      },
      efetuaLogin(usuario, tipo = 1) {
        this.spinner2 = true;
        
        let array = this.setarSemana(usuario);
        // this.autenticarUsuario(array)
        this.autenticarUsuario({
          usuario: array,
          onSucesso: (usuario, existe) => {
            this.focusInput('select_empresa')
            this.step = 1
            
            this.spinner2 = false;
            if (tipo === 1) {
              if (this.reloadPage) {
                document.location.reload(true)
              } else {
                this.setarToken(sessionStorage.getItem('token'), sessionStorage.getItem('funcionario_id'))
              }
              this.user.username = '';
              this.user.senha = '';
              this.fechaModal()
              
            } else {
              this.setEmpresaByFuncionario({
                funcionario: sessionStorage.getItem('funcionario_id'),
                onSucesso: () => {
                  if (usuario.empresas.length >= 2) {
                    this.varias_empresas = true
                  } else {
                    let empresa = this.listaAllEmpresaFunc.filter(list => list.empresa_id === usuario.empresas[0].empresa_id);
                    if (empresa.length > 0) {
                      this.dadosSessao(empresa[0])
                    }
                    this.confirmar()
                  }
                }
              });
              if (!existe) {
                let tema = new Tema(usuario.funcionario_id);
                tema.cor = '#000000';
                tema.opacidade = 0.8;
                this.setTema(tema)
              } else {
                this.setTema(usuario.original[0])
              }
              
            }
          },
          onErro: () => {
            this.step = 0
            this.spinner2 = false;
          },
        })
      },
      PressEnter(senha, usuario, tipo = 1) {
        let _this = this;
        let user = document.getElementById('usuario');
        let senhaId = document.getElementById('senha');
        
        user.addEventListener('keypress', function (e) {
          if (e.keyCode === 13 || e.which === 13) {
            if (!_this.validarCampo(usuario)) {
              user.focus()
            } else if (!_this.validarCampo(senha)) {
              senhaId.focus()
            } else {
              _this.efetuaLogin(_this.user, tipo)
            }
          }
        }, false);
        
        senhaId.addEventListener('keypress', function (e) {
          if (e.keyCode === 13 || e.which === 13) {
            if (!_this.validarCampo(senha)) {
              senhaId.focus()
            } else {
              if (!_this.validarCampo(usuario)) {
                user.focus()
              } else {
                _this.efetuaLogin(_this.user, tipo)
              }
            }
          }
        }, false)
      },
      fechaModal() {
        this.varias_empresas = !this.varias_empresas
      },
      
      
    },
    mounted() {
      // this.carregarEmpresa()
      this.user = {
        username: "",
        senha: "",
        acessibilidade: {dia: '', hora: ''}
      }
      
      
    },
    computed: {
      ...mapState('geral', {
        darkTheme: 'darkTheme',
        dialogError: 'dialogError',
        objMsgError: 'objMsgError',
        snackSuccess: 'snackSuccess',
        msgSuccess: 'msgSuccess'
      }),
      ...mapGetters('empresa', ['listaAllEmpresaFunc']),
      
      showSnack: {
        get() {
          return this.snackSuccess
        },
        set() {
          this.toggleSnackSuccess()
        }
      }
    },
    watch: {
      empresa: function () {
        this.dadosSessao(this.empresa)
      }
    }
  }
</script>
<style scoped lang="scss">
  .app-login {
    background: transparent !important;
    background-image: linear-gradient(130deg, rgba(#000, 0.1) 30%, rgba(#000, 0.1) 100%), url("../../assets/img/fundo/fundo (6).jpg") !important;
    background-size: 100% 100% !important;
    background-repeat: no-repeat;
    min-height: 100vh;
  }
</style>
